var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4366 1.8331C6.38732 1.8331 2.29492 5.9255 2.29492 10.9748C2.29492 15.0131 4.91351 18.4401 8.54671 19.6499C9.00407 19.7324 9.16905 19.451 9.16905 19.2091C9.16905 18.9918 9.16172 18.4162 9.15897 17.6546C6.61554 18.2063 6.07844 16.4282 6.07844 16.4282C5.66416 15.3724 5.06382 15.091 5.06382 15.091C4.23434 14.5237 5.12706 14.5365 5.12706 14.5365C6.04544 14.6006 6.52663 15.4787 6.52663 15.4787C7.34236 16.8755 8.66769 16.4722 9.18646 16.2385C9.26987 15.6473 9.50817 15.2441 9.76847 15.0158C7.73923 14.7858 5.6055 14.0012 5.6055 10.4972C5.6055 9.50096 5.96204 8.68339 6.54405 8.04548C6.45148 7.81359 6.13527 6.88329 6.63479 5.62578C6.63479 5.62578 7.40194 5.37923 9.14797 6.56158C9.89367 6.35872 10.6629 6.25517 11.4357 6.25362C12.2085 6.25487 12.9777 6.35843 13.7234 6.56158C15.4703 5.37831 16.2366 5.62578 16.2366 5.62578C16.7361 6.88329 16.4226 7.81359 16.3273 8.04548C16.9139 8.68339 17.2658 9.50004 17.2658 10.4972C17.2658 14.0104 15.1303 14.7821 13.0937 15.0085C13.4191 15.2908 13.7124 15.8481 13.7124 16.7005C13.7124 17.9231 13.7014 18.9093 13.7014 19.2091C13.7014 19.4538 13.8645 19.7379 14.3311 19.6481C17.9624 18.4364 20.5783 15.0122 20.5783 10.9748C20.5783 5.9255 16.4859 1.8331 11.4366 1.8331Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.a01a130abcbcf6fdb148e96d97ca658a.svg";
export { ForwardRef as ReactComponent };